<template>
  <div class="handout">
    <b-link class="link-open" :href="file.href" target="_blank"
        @click="clickDownload">
      <img class="thumbnail" v-if="isImage" :src="file.href" @error="imageError = true" />
      <file-icon class="thumbnail" v-else :fileType="file.type"></file-icon>

      <span class="filename">{{ file.name }}</span>
    </b-link>

    <b-link v-if="showDownload" class="link-download" target="_blank"
      @click="clickDownload"
      :href="file.href" :download="file.name">
      <icon kind="download"></icon>
    </b-link>
  </div>
</template>

<script>
import Icon from '@/components/togo/icon';
import FileIcon from '@/components/togo/file-icon';

const Handout = {
  name: 'Handout',

  props: {
    file: {
      type: Object,
      required: true
    },
    showDownload: {
      type: Boolean,
      default: false
    }
  },

  components: {
    Icon,
    FileIcon
  },

  data() {
    return {
      imageError: false
    };
  },

  computed: {
    isImage() {
      return !this.imageError && /jpeg|jpg|png|gif/i.test(this.file.type);
    }
  },

  methods: {
    clickDownload() {
      this.$telemetryTrack('handout clicked', {fileType: this.file.type});
    }
  }
};

export default Handout;
</script>

<style lang="sass">
  @import "src/scss/variables"

  .handout
    display: flex
    align-items: center
    justify-content: space-between

    .link-open
      display: flex
      align-items: center
      width: 100%

      .thumbnail
        min-width: 64px
        max-width: 64px
        max-height: 64px
        border-radius: 5px

      .filename
        font-size: 14px
        margin-left: 10px
        max-height: 64px
        overflow-y: auto
        word-wrap: break-word
        overflow-wrap: break-word

    .link-download
      display: flex
      justify-content: center
      align-items: center
      min-width: 39px
      width: 39px
      height: 39px
      border-radius: 50%
      color: #6944e5
      font-size: 20px

      &:hover
        color: $white
        background-color: #7b54f7
</style>
